<div class="card m-0 p-0">
<div class="col-12 d-flex " [class.justify-content-center]="button.button_style === '1010'" [class.justify-content-start]="button.button_style === '1100'" [class.justify-content-end]="button.button_style === '1001'" >
  <qrcode *ngIf="mobViewBuilder" width="50" [qrdata]="qrcode_value" [errorCorrectionLevel]="'M'"></qrcode>
  <qrcode *ngIf="!mobViewBuilder"  [qrdata]="qrcode_value" [errorCorrectionLevel]="'M'"></qrcode>
</div>
</div>
